import { render, staticRenderFns } from "./iconFlotante.vue?vue&type=template&id=e2d0c3b6&"
import script from "./iconFlotante.vue?vue&type=script&lang=js&"
export * from "./iconFlotante.vue?vue&type=script&lang=js&"
import style0 from "./iconFlotante.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports